import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";

const Blog = () => {
  const options = {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,  // Ensure pagination bullets are clickable
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  };

  return (
    <section className='team-bg' id='news'>
      <div className='animation-circle-inverse'>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <Container>
        <Row>
          <Col md='8' className='offset-md-2 text-center'>
            <div className='section-title'>
              <h2>Our Recent Blog</h2>
              <img src='assets/images/title-line.png' alt='/title-line' />
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem autem voluptatem obcaecati! ipsum dolor sit Rem autem voluptatem obcaecati</p>
            </div>
          </Col>
          <Col md='12'>
            <Swiper className='news-carousel' {...options}>
              {[...Array(6)].map((_, i) => (
                <SwiperSlide key={i} className='news-slid'>
                  <div className='news-box'>
                    <Link>
                      <img src={`assets/images/blog/${i + 1}.jpg`} alt='news-1' className='img-fluid' />
                    </Link>
                    <div className='blog-hover'>
                      <h4>lorem ipsum dolor sit amet</h4>
                      <ul className='list-inline blog-details-list'>
                        <li><Link>John Doe</Link></li>
                        <li><Link>28 Dec</Link></li>
                        <li><Link>25 comments</Link></li>
                        <li><Link>3 View</Link></li>
                      </ul>
                    </div>
                  </div>
                  <div className='news-text'>
                    <p>lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.</p>
                    <Link className='btn-theme'>View more</Link>
                  </div>
                </SwiperSlide>
              ))}
              <div className="swiper-pagination"></div> 
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Blog;
